{
  "enum": {
    "IxcPaymentsV1AccountNumberStatus": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPaymentsV1AchStatus": {
      "CANCELED": "Canceled",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "RETURNED": "Returned",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPaymentsV1IncomingAchStatus": {
      "RETURNED": "Returned",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPaymentsV1IncomingWireStatus": {
      "REVERSED": "Reversed",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPaymentsV1WireStatus": {
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "REVERSED": "Reversed",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcPaymentsV1AccountNumberQueryServiceAccountNumberListFilterableFields": {
      "accountNumberId": "Account Number",
      "data": {
        "externalId": "External ID",
        "spec": {
          "accountId": "Account",
          "programId": "Program"
        }
      },
      "status": "Status"
    },
    "IxcPaymentsV1AchQueryServiceAchListFilterableFields": {
      "achId": "ACH",
      "data": {
        "spec": {
          "accountId": "Account",
          "programId": "Program",
          "sourceId": "Source",
          "transferId": "Transfer"
        }
      },
      "status": "Status"
    },
    "IxcPaymentsV1IncomingAchQueryServiceIncomingAchListFilterableFields": {
      "achId": "ACH",
      "data": {
        "spec": {
          "accountId": "Account",
          "accountNumberId": "Account Number",
          "programId": "Program",
          "transferId": "Transfer"
        }
      },
      "status": "Status"
    },
    "IxcPaymentsV1IncomingWireQueryServiceIncomingWireListFilterableFields": {
      "data": {
        "spec": {
          "accountId": "Account",
          "accountNumberId": "Account Number",
          "programId": "Program",
          "transferId": "Transfer"
        }
      },
      "status": "Status",
      "wireId": "Wire"
    },
    "IxcPaymentsV1WireQueryServiceWireListFilterableFields": {
      "data": {
        "spec": {
          "accountId": "Account",
          "programId": "Program",
          "sourceId": "Source",
          "transferId": "Transfer"
        }
      },
      "status": "Status",
      "wireId": "Wire"
    }
  },
  "oneOf": {
    "IxcPaymentsV1AccountNumberEventType": {
      "created": "Created",
      "disabled": "Disabled",
      "reenabled": "Re-Enabled",
      "requested": "Requested"
    },
    "IxcPaymentsV1AchEventType": {
      "canceled": "Canceled",
      "created": "Created",
      "rejected": "Rejected",
      "returned": "Returned",
      "settled": "Settled"
    },
    "IxcPaymentsV1IncomingAchEventType": {
      "returned": "Returned",
      "settled": "Settled"
    },
    "IxcPaymentsV1IncomingWireEventType": {
      "reversed": "Reversed",
      "settled": "Settled"
    },
    "IxcPaymentsV1WireEventType": {
      "created": "Created",
      "rejected": "Rejected",
      "reversed": "Reversed",
      "settled": "Settled"
    }
  },
  "searchEnum": {
    "IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSearchableFields": {
      "data": {
        "bankDetails": {
          "accountNumber": "Data Bank Details Account Number"
        }
      }
    },
    "IxcPaymentsV1AchQueryServiceAchListSearchableFields": {
      "data": {
        "spec": {
          "achSource": {
            "bankDetails": {
              "accountNumber": "Data Spec ACH Source Bank Details Account Number"
            }
          }
        }
      }
    },
    "IxcPaymentsV1WireQueryServiceWireListSearchableFields": {
      "data": {
        "spec": {
          "domesticWireSource": {
            "bankDetails": {
              "accountNumber": "Data Spec Domestic Wire Source Bank Details Account Number"
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcPaymentsV1AccountNumberQueryServiceAccountNumberListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPaymentsV1AchQueryServiceAchListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPaymentsV1IncomingAchQueryServiceIncomingAchListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPaymentsV1IncomingWireQueryServiceIncomingWireListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPaymentsV1WireQueryServiceWireListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}